import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';

import { authBunja } from '@flipster/features/src/shared/auth/state';
import { getFlipsterConfigsV1Key, getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

import { isPipSupported } from './pip';

export const pipModeConfigBunja = bunja(() => {
  const { userAtom } = bunja.use(authBunja);
  const pipModeConfigBaseAtom = atomWithDefault((get) => {
    if (!isPipSupported) return false;

    const defaultValue = true;
    const user = get(userAtom);
    if (!user) return defaultValue;
    const storageValue = getLocalStorage(getFlipsterConfigsV1Key(user.userId, 'pipMode'));

    return typeof storageValue === 'boolean' ? storageValue : defaultValue;
  });

  const pipModeConfigAtom = atom(
    (get) => get(pipModeConfigBaseAtom),
    (get, set, value: boolean) => {
      const user = get(userAtom);
      if (!user) return;
      setLocalStorage(getFlipsterConfigsV1Key(user.userId, 'pipMode'), value);
      return set(pipModeConfigBaseAtom, value);
    },
  );

  return { pipModeConfigAtom };
});
pipModeConfigBunja.debugLabel = 'pipModeConfigBunja';
